<div
  class="d-flex justify-content-start align-items-start"
  style="background-color: #f8f4f4"
>
  <!-- Vertical Progress Bar -->
  <div
    class="progress-container"
    style="width: 100px; margin-right: 20px; position: absolute; left: 0"
  >
    <div class="progress-bar-vertical" style="position: relative">
      <div
        class="progress-bar-fill"
        style="position: absolute; top: 0;"
        [style.height]="progress + '%'"
      ></div>
    </div>

    <span
      [style.top]="progress - 5 + '%'"
      class="progress-percent-label"
    >
      {{ progressText }}
    </span>
  </div>

  <div
    class="p-4 shadow"
    style="margin-bottom: 40px; background-color: white; width: 100%"
  >
    <h1 class="text-center">Product Choice</h1>

    <!-- First Stage: Product Selection -->
    <div *ngIf="!selectedProductId">
      <h3 class="text-center mt-5">Ranges</h3>
      <p class="text-center">
        Once you have selected the Range, only the available Models/Styles for
        that Range will be able to be selected.
      </p>
      <div class="d-flex justify-content-around mt-3 flex-wrap">
        <button
          *ngFor="let product of products;"
          class="btn-product"
          style="border-radius: 5px; background-color: #f5f5f5"
          [class.active]="product.productId === selectedProductId"
          (click)="onSelectProduct(product.productId)"
        >
          {{ product.name }}
        </button>
      </div>
    </div>

    <!-- Stage After Product Selection -->
    <div *ngIf="selectedProductId">
      <div class="d-flex justify-content-center align-items-center">
        <h3 class="text-center">Ranges</h3>
        <button class="btn-arrow" (click)="goBackToProductSelection()">
          <img
            src="../../../assets/chevron-down.png"
            alt="Back"
            style="width: 24px"
          />
        </button>
      </div>
      <div class="text-center mt-4">
        <button
          class="btn-product active"
          style="border-radius: 5px; background-color: #00b4e6; color: white"
        >
          {{ getSelectedProductName() }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-order-flow-model-choice
(progressUpdated)="updateProgress($event)"
[models]="models"
[attributes]="attributes"
[options]="options"
[selectedModelFromDuplicate]="selectedModelIdFromDuplicateAction"
></app-order-flow-model-choice>
